/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */
import { faker } from "@faker-js/faker"
import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

import type { JobStatusResponse } from ".././types"

export const getGetJobStatusResponseMock = (): JobStatusResponse => ({
	jobId: "550e8400-e29b-41d4-a716-446655440000",
	status: "pending",
	reportType: "general_appointments",
	name: "general-appointments-2025-01-15",
	format: "pdf",
	extension: "pdf",
})

export const getDownloadReportResponseMock = (): ArrayBuffer =>
	faker.helpers.arrayElement([
		new ArrayBuffer(faker.number.int({ min: 1, max: 64 })),
		new ArrayBuffer(faker.number.int({ min: 1, max: 64 })),
	])

export const getGetJobStatusMockHandler = (
	overrideResponse?:
		| JobStatusResponse
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<JobStatusResponse> | JobStatusResponse),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/reports/jobs/:jobId",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			return HttpResponse.json(
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getGetJobStatusResponseMock(),
				{ status: 200 },
			)
		},
		options,
	)
}

export const getDownloadReportMockHandler = (
	overrideResponse?:
		| ArrayBuffer
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<ArrayBuffer> | ArrayBuffer),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/reports/jobs/:jobId/download",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)

			const binaryBody =
				overrideResponse !== undefined
					? typeof overrideResponse === "function"
						? await overrideResponse(info)
						: overrideResponse
					: getDownloadReportResponseMock()
			return HttpResponse.arrayBuffer(
				binaryBody instanceof ArrayBuffer ? binaryBody : new ArrayBuffer(0),
				{ status: 200, headers: { "Content-Type": "application/pdf" } },
			)
		},
		options,
	)
}
export const getJobsMock = () => [
	getGetJobStatusMockHandler(),
	getDownloadReportMockHandler(),
]
